import vertexShaderSrc from './vertex.vert';
import fragmentShaderSrc from './fragment.frag';
import { convertToVec3 } from '../../utils/commonUtils';
import * as PIXI from 'pixi.js';
import AssetsLoader from '../../utils/assetsLoader';

export default class CardHighlightFilter extends PIXI.Filter {
    static initialValues = {
        borderStrength: 2.3,
        borderSize: 0.68,
        effectStrength: 1.9,
        effectColor: '#0084ff',
    }

    constructor() {
        const glProgram = PIXI.GlProgram.from({
            vertex: vertexShaderSrc,
            fragment: fragmentShaderSrc,
            name: 'card_highlight',
        });

        const noiseTexture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.HIGHLIGHT_EFFECT_NOISE);
        noiseTexture.source.addressMode = 'repeat';

        super({
            glProgram,
            resources: {
                timeUniforms: {
                    uTime: { value: 0.0, type: 'f32' },
                },
                effectUniforms: {
                    uBorderStrength: { value: CardHighlightFilter.initialValues.borderStrength, type: 'f32' },
                    uEffectStrength: { value: CardHighlightFilter.initialValues.effectStrength, type: 'f32' },
                    uEffectColor: { value: convertToVec3(CardHighlightFilter.initialValues.effectColor), type: 'vec3<f32>' },
                },
                uNoiseTexture: noiseTexture.source,
            }
        });
    }

    setHighlightParameters(borderStrength, effectStrength, effectColor) {
        this.resources.effectUniforms.uniforms.uBorderStrength = borderStrength;
        this.resources.effectUniforms.uniforms.uEffectStrength = effectStrength;
        this.resources.effectUniforms.uniforms.uEffectColor = convertToVec3(effectColor);
    }
}